import { useSessionStore } from '../store/sessionStore.js';
import { useTabsStore } from '../store/tabsStore.js';
import { useCartStore } from '../store/cartStore.js';

// El último comercio al que entró este aparato. Va aparte de la sesión porque
// al cerrar sesión se borra el comercio de `gc-pos-auth`, y justo lo que hay
// que saber al volver a entrar es si es el mismo de antes.
const LLAVE = 'gc-pos-comercio';

const leer = () => {
  try { return localStorage.getItem(LLAVE); } catch { return null; }
};
const guardar = (id) => {
  try { localStorage.setItem(LLAVE, id); } catch { /* sin almacenamiento: se decide con la sesión */ }
};

/**
 * Llamar justo antes de guardar el login. Si el aparato entra a un comercio
 * distinto del anterior, suelta lo que era del otro: el turno de caja, la
 * cuenta abierta en el carrito y lo que hubiera capturado en él.
 *
 * Lo pendiente de enviar NO se toca aquí: cada entrada de la cola sabe de qué
 * comercio es y solo sale cuando se está dentro de ese (outboxStore).
 *
 * Entrar otra vez al MISMO comercio —se venció la sesión, se cerró y se volvió
 * a abrir— no suelta nada: un mesero a media comanda no debe perderla por eso.
 */
export const alEntrarAComercio = (tenantId) => {
  const nuevo = tenantId ? String(tenantId) : null;
  if (!nuevo) return;

  const anterior = leer();
  const sesion   = useSessionStore.getState().session;
  // Sin marca previa (primera vez con esta versión), el turno guardado dice de
  // qué comercio venía el aparato.
  const deOtro = anterior
    ? anterior !== nuevo
    : !!(sesion?.tenant_id && String(sesion.tenant_id) !== nuevo);

  if (deOtro) {
    useSessionStore.getState().closeSession();
    useTabsStore.setState({ tabs: [], activeTabId: null, base: null, inflight: null, loaded: false, error: null });
    useCartStore.getState().clearCart();
  }
  guardar(nuevo);
};

export const ultimoComercio = leer;
